export default "__VITE_ASSET__32508ab2__"